export function getAccountfromUrl(url: string) {
  const possibleId = url
    .split('/')
    .filter(Boolean)
    .find(item => item.startsWith('p-'));

  if (possibleId?.startsWith('p-')) {
    return possibleId?.slice(2);
  }
  return null;
}
